import { render, staticRenderFns } from "./ProvinceCity.vue?vue&type=template&id=61b55f3a&"
import script from "./ProvinceCity.vue?vue&type=script&lang=js&"
export * from "./ProvinceCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports